import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { TagList } from '../../tags/components/TagList';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejTagListPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper appType={APP_TYPE.VYDEJ} menu={<VydejMenu />} resource='Tags' action='list.view'>
          <TagList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejTagListPage;
